import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { CognitoService } from './cognito.service';
import { BasicPath } from '../path';

const logged = async(): Promise<boolean> => {
    const cognitoService = inject(CognitoService);
    const session = await cognitoService.getSession();
    return !!session.tokens?.accessToken;
}

export const isLogged = async (): Promise<boolean> => {
  const router = inject(Router);
  const hasToken = await logged();
  if (!hasToken) {
    router.navigate([BasicPath.AUTH]);
  }
  return hasToken;
};

export const isNotLogged = async (): Promise<boolean> => {
  return !(await logged());
};
